__webpack_require__.p = "/reports-requisition-metric/referrals-hub/";